module.exports = __webpack_public_path__ + "img/Sakralbau_3_a.44c8c924.jpg";